export default __webpack_public_path__ + "static/shopping-banner-go-9b393784abc0c1d6872a341ff7d7a993.webp";